// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c3db55c9","732":"1b3e777a"}[chunkId] + ".chunk.js";
};